import React, { useState } from 'react';
import styled from 'styled-components';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { initialTranscodeAdmin } from '../services/api/admin_attachments.js';

const AdminAttachmentTranscode = () => {
    const [attachmentId, setAttachmentId] = useState('');
    const [updateApi, setUpdateApi] = useState(true);
    const [message, setMessage] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!attachmentId) {
            setMessage('Attachment ID is required');
            return;
        }
        initialTranscodeAdmin(attachmentId, updateApi)
            .then(() => setMessage('Request sent'))
            .catch(() => setMessage('Error sending request'));
    };

    return (
        <Page>
            <h1>Initial Transcode</h1>
            <Form style={{width: '300px'}} onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                    <Form.Label>Attachment ID</Form.Label>
                    <Form.Control
                        type="text"
                        value={attachmentId}
                        onChange={(e) => setAttachmentId(e.target.value)}
                    />
                </Form.Group>
                <Form.Group className="mb-3" controlId="updateApiCheck">
                    <Form.Check
                        type="checkbox"
                        label="Update API"
                        checked={updateApi}
                        onChange={(e) => setUpdateApi(e.target.checked)}
                    />
                </Form.Group>
                <Button variant="primary" type="submit">
                    Submit
                </Button>
            </Form>
            {message && <p>{message}</p>}
        </Page>
    );
};

export default AdminAttachmentTranscode;

const Page = styled.div`
    position: absolute;
    flex-flow: column nowrap;
    top: 70px;
    display: flex;
    height: calc(100vh - 70px);
    width: 100vw;
    align-items: center;
    overflow: auto;
`;
